module.exports = __webpack_public_path__ + "assets/images/JMDBAG1.png";


//////////////////
// WEBPACK FOOTER
// ./client/app/assets/images/JMDBAG1.png
// module id = 1390
// module chunks = 1